import { motion } from "framer-motion";

// Define animation variants type inline
type AnimationVariants = {
  [key: string]: {
    [key: string]: any;
    transition?: any;
  };
};

export const AnimatedChartContainer: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={chartVariants}
      style={{ width: "100%", height: "100%" }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
    >
      {children}
    </motion.div>
  );
};

// Animation variants with enhanced effects but faster timings
export const containerVariants: AnimationVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.4,
      when: "beforeChildren",
      staggerChildren: 0.15,
      ease: "easeOut",
    },
  },
};

// Enhanced chart animations with more dynamic effects but faster
export const chartVariants: AnimationVariants = {
  hidden: { opacity: 0, scale: 0.9, y: 30 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.5,
      type: "spring",
      stiffness: 120,
      damping: 10,
    },
  },
};

// Title animation with faster effect
export const titleVariants: AnimationVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 400,
      damping: 18,
      delay: 0.1,
    },
  },
};

// Legend animation with faster fade and slide
export const legendVariants: AnimationVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      delay: 0.2,
      ease: "easeOut",
    },
  },
};
